<script>
export default {
	props: ['order', 'checkout'],
}
</script>

<template>
	<TransbankCardContent />
</template>
